import MyAnnouncements from "@/views/console/MyAnnouncements";
import C from "@/utils/constants";

export default [
  {
    path: "my-announcements",
    component: MyAnnouncements,
    meta: {
      roles: [C.ROLE.ADMIN, C.ROLE.AGENT_ENGAGEMENT, C.ROLE.BROKERAGE_ADMIN],
    },
    children: [
      {
        path: "",
        name: "my-announcements",
        component: () =>
          import("@/components/console/my-announcements/MyAnnouncementsList"),
        meta: {
          roles: [
            C.ROLE.ADMIN,
            C.ROLE.AGENT_ENGAGEMENT,
            C.ROLE.BROKERAGE_ADMIN,
            C.ROLE.MANAGER,
            C.ROLE.CSR_SUPERVISOR,
          ],
          hotjar: true,
        },
      },
      // { path: "view", redirect: "/console/my-admins" },
      // {
      //   path: "view/:id",
      //   name: "view-my-admin",
      //   components: {
      //     default: () => import("@/components/console/my-admins/MyAdminsList"),
      //     view: () => import("@/components/console/my-admins/MyAdminDetail")
      //   },
      //   props: {
      //     view: route => {
      //       return {
      //         mode: "view",
      //         adminId: route.params.id,
      //         parent: "my-admins"
      //       };
      //     }
      //   },
      //   meta: {
      //     roles: [C.ROLE.ADMIN, C.ROLE.AGENT_ENGAGEMENT, C.ROLE.BROKERAGE_ADMIN]
      //   }
      // }
    ],
  },
];
